import SuspenseDimmer from "global/components/alerts/SuspenseDimmer"
import TrackerProvider from "./TrackerContext"
import SportsOrganizationProvider from "projectSpecific/sports/cnr/contexts/SportsOrganizationContext"
import SportsDistrictProvider from "projectSpecific/sports/cnr/contexts/SportsDistrictContext"
import SportsSeasonProvider from "projectSpecific/sports/cnr/contexts/SportsSeasonContext"
import React, { Suspense } from "react"
import GolfTournamentProvider from "projectSpecific/golf/cnr/contexts/GolfTournamentContext"

export const SportsSeasonLayout = React.memo(({ children, organizationsKey, districtsKey, sportsKey }) => {
  return (
    <Suspense fallback={<SuspenseDimmer origin='PageComponentContext' />}>
      <TrackerProvider>
        <SportsOrganizationProvider organizationsKey={organizationsKey}>
          <SportsDistrictProvider districtsKey={districtsKey}>
            <SportsSeasonProvider sportsKey={sportsKey}>
              {children}
            </SportsSeasonProvider>
          </SportsDistrictProvider>
        </SportsOrganizationProvider>
      </TrackerProvider>
    </Suspense>
  )
})

export const SportsDistrictLayout = React.memo(({ children, organizationsKey, districtsKey }) => {
  return (
    <Suspense fallback={<SuspenseDimmer origin={'PageComponentContext'} />}>
      <SportsOrganizationProvider organizationsKey={organizationsKey}>
        <SportsDistrictProvider districtsKey={districtsKey}>
          {children}
        </SportsDistrictProvider>
      </SportsOrganizationProvider>
    </Suspense>
  )
})

export const SportsOrganizationLayout = React.memo(({ children, organizationsKey }) => {
  return (
    <Suspense fallback={<SuspenseDimmer origin={'PageComponentContext'} />}>
      <SportsOrganizationProvider organizationsKey={organizationsKey}>
        {children}
      </SportsOrganizationProvider>
    </Suspense>
  )
})

export const GolfLayout = React.memo(({ children }) => {
  return (
    <Suspense fallback={<SuspenseDimmer origin={'PageComponentContext'} />}>
      <GolfTournamentProvider fromPage={true}>
        {children}
      </GolfTournamentProvider>
    </Suspense>
  )
})